import PlentyApiClient from "./base";

// Stock/Purchase History API
export const stockApi = {
  // Purchase History CRUD
  createPurchaseRecord: (purchaseData) => {
    return PlentyApiClient.post("/stock/", purchaseData);
  },

  getPurchaseRecords: (params = {}) => {
    const { sku, start_date, end_date, limit = 100, offset = 0 } = params;
    return PlentyApiClient.get("/stock/", {
      params: { sku, start_date, end_date, limit, offset },
    });
  },

  getPurchaseRecord: (purchaseId) => {
    return PlentyApiClient.get(`/stock/${purchaseId}`);
  },

  updatePurchaseRecord: (purchaseId, updateData) => {
    return PlentyApiClient.put(`/stock/${purchaseId}`, updateData);
  },

  deletePurchaseRecord: (purchaseId) => {
    return PlentyApiClient.delete(`/stock/${purchaseId}`);
  },

  // SKU-specific queries
  getAverageCostBySku: (sku, params = {}) => {
    const { start_date, end_date } = params;
    return PlentyApiClient.get(`/stock/sku/${sku}/average-cost`, {
      params: { start_date, end_date },
    });
  },

  getLatestPurchaseBySku: (sku) => {
    return PlentyApiClient.get(`/stock/sku/${sku}/latest`);
  },

  getAllStockDataBySku: (sku) => {
    return PlentyApiClient.get(`/stock/by-sku/${sku}`);
  },

  // Stock Value Calculation
  calculateStockValues: (params = {}) => {
    const { min_stock = 1, dry_run = false, snapshot_date = null } = params;

    // Build query params
    const queryParams = { min_stock, dry_run };
    if (snapshot_date) queryParams.snapshot_date = snapshot_date;

    return PlentyApiClient.post("/stock/calculate-stock-values", null, {
      params: queryParams,
    });
  },

  getTotalStockValue: (days = null) => {
    const params = days ? { days } : {};
    return PlentyApiClient.get("/stock/total-stock-value", { params });
  },

  // Import purchase history from shopping_table
  importFromShoppingTable: (params = {}) => {
    const { skip_existing = false } = params;
    return PlentyApiClient.post("/stock/import-from-shopping-table", null, {
      params: { skip_existing },
    });
  },

  // Get SKUs without purchase history
  getSkusWithoutPurchaseHistory: (params = {}) => {
    const { min_stock = 0, source = null } = params;
    const queryParams = { min_stock };
    if (source) queryParams.source = source;
    return PlentyApiClient.get("/stock/skus-without-purchase-history", {
      params: queryParams,
    });
  },
};
